// extracted by mini-css-extract-plugin
export var actionIcon = "_sv-0";